import { GLOBALTYPES } from "../actions/globalTypes";

const socketReducer = (state = { socketdata: null }, action) => {
  switch (action.type) {
    case GLOBALTYPES.SOCKET:
      return { ...state, socket: action.payload };
    default:
      return state;
  }
};

export default socketReducer;
